<div class="empty-basket">
  <p>
    {{ label | i18next }}
  </p>
</div>
